import React, { useState } from 'react';
import ModalBtn from '../../molecules/modalButton/view';
import InputDirectory from '../../atoms/inputDirectory/view';
import CargaMasivaTable from '../cargaMasivaTable/view';
import BatchExcelTemplateButton from '../../molecules/BatchExcelTemplateButton/view';
import { useCargaMasiva } from '../../../usecases/useCargaMasiva';
import ButtonPrimary from '../../atoms/ButtonPrimary/view';
import { BiCloudUpload, BiTrash, BiArrowBack, BiFile, BiFolderOpen } from 'react-icons/bi';
import { formatMoney } from '../../../utils/formating';
import './style.css';

const CargaMasivaModal = () => {
    const {
        comprobantes,
        isProcessing,
        uploadProgress,
        parseProgress,
        processFiles,
        removeComprobante,
        uploadAll,
        clear
    } = useCargaMasiva();

    const [selectedDocId, setSelectedDocId] = useState(null);

    const pendingCount = comprobantes.filter(c => c.isValid && (c.status === 'pending' || c.status === 'error')).length;
    const totalCount = comprobantes.length;

    const renderDetail = () => {
        const doc = comprobantes.find(c => c.id === selectedDocId);
        if (!doc) return null;

        return (
            <div className="carga-masiva-detail h-100 d-flex flex-column" style={{ overflow: 'hidden' }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0 fw-bold text-primary">Detalle: {doc.file_name}</h5>
                    <button className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1" onClick={() => setSelectedDocId(null)}>
                        <BiArrowBack /> Volver a la lista
                    </button>
                </div>

                <div className="row mb-3 gx-3 bg-light p-3 rounded mx-0">
                    <div className="col-md-6">
                        <p className="mb-1 text-muted small">Descripción</p>
                        <p className="fw-bold mb-0">{doc.cabecera.descripcion}</p>
                        <p className="mb-1 text-muted small mt-2">Tipo de Documento</p>
                        <p className="fw-bold mb-0">{doc.cabecera.document_type}</p>
                    </div>
                    <div className="col-md-6 text-end">
                        <p className="mb-1 text-muted small">Total Débito</p>
                        <p className="fw-bold text-dark mb-0 fs-5">{formatMoney(doc.total_debito)}</p>
                        <p className="mb-1 text-muted small mt-2">Total Crédito</p>
                        <p className="fw-bold text-dark mb-0 fs-5">{formatMoney(doc.total_credito)}</p>
                    </div>
                </div>

                <div className="table-responsive flex-grow-1 border rounded">
                    <table className="table table-sm table-hover mb-0" style={{ fontSize: '0.85rem' }}>
                        <thead className="table-light sticky-top">
                            <tr>
                                <th className="text-muted">#</th>
                                <th className="text-muted">Cuenta</th>
                                <th className="text-muted">Tercero</th>
                                <th className="text-muted">Detalle</th>
                                <th className="text-end text-muted">Débito</th>
                                <th className="text-end text-muted">Crédito</th>
                            </tr>
                        </thead>
                        <tbody>
                            {doc.lineas.map((l, i) => {
                                const accountObj = l.cuenta_object || l.aditional_info;
                                const accountName = accountObj ? `${accountObj.base_account?.account}${String(accountObj.code).padStart(2, '0')} - ${accountObj.base_account?.description}` : l.cuenta_contable_id;
                                const thirdName = l.tercero_object ? (l.tercero_object.business_name || l.tercero_object.name || l.tercero_object.identification) : (l.tercero_id || '-');
                                const detailText = l.detalle || l.descripcion || '-';
                                const dValue = l.debito ?? l.valor_debito ?? 0;
                                const cValue = l.credito ?? l.valor_credito ?? 0;

                                return (
                                    <tr key={i}>
                                        <td className="align-middle fw-bold">{l.numero_linea}</td>
                                        <td className="align-middle">{accountName}</td>
                                        <td className="align-middle">{thirdName}</td>
                                        <td className="align-middle text-truncate" style={{ maxWidth: '150px' }} title={detailText}>{detailText}</td>
                                        <td className="align-middle text-end text-success fw-bold">{formatMoney(dValue)}</td>
                                        <td className="align-middle text-end text-danger fw-bold">{formatMoney(cValue)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    return (
        <ModalBtn
            id="cargaMasivaComprobantes"
            title="Carga Masiva"
            icon={<BiCloudUpload />}
            className="btn-carga-masiva"
            width="98vw"
            style={{ width: '98vw', height: '95vh', maxWidth: '98vw', maxHeight: '95vh' }}
            onClose={() => {
                clear();
                setSelectedDocId(null);
            }}
        >
            <div className="carga-masiva-container">
                <div className="carga-masiva-header">
                    <div className="d-flex justify-content-between align-items-start">
                        <div>
                            <h4 className="mb-1">Carga Masiva de Comprobantes</h4>
                            <p className="text-muted small mb-1">
                                Selecciona una carpeta con archivos Excel. Cada archivo será procesado como un comprobante individual.
                            </p>
                            <BatchExcelTemplateButton />
                        </div>
                        <div className="d-flex gap-2">
                            {totalCount > 0 && (
                                <button className="btn btn-outline-danger btn-sm d-flex align-items-center gap-1" onClick={() => { clear(); setSelectedDocId(null); }} disabled={isProcessing}>
                                    <BiTrash size={16} /> Limpiar Todo
                                </button>
                            )}
                            <InputDirectory
                                mode="files"
                                icon={<BiFile size={20} />}
                                onFilesSelected={processFiles}
                                disabled={isProcessing}
                                label="Archivos"
                            />
                            <InputDirectory
                                mode="folder"
                                icon={<BiFolderOpen size={20} />}
                                onFilesSelected={processFiles}
                                disabled={isProcessing}
                                label="Carpeta"
                            />
                        </div>
                    </div>
                </div>

                <div className="carga-masiva-body">
                    <div className="table-wrapper-container p-0">
                        {selectedDocId ? (
                            <div className="p-3 h-100">
                                {renderDetail()}
                            </div>
                        ) : (
                            <CargaMasivaTable
                                data={comprobantes}
                                onRemove={removeComprobante}
                                onView={setSelectedDocId}
                            />
                        )}
                    </div>
                </div>

                <div className="carga-masiva-footer">
                    <div className="flex-grow-1">
                        {parseProgress?.isParsing && (
                            <div className="upload-progress-bar mb-0 me-4">
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="small fw-bold text-info">
                                        Analizando archivos locales... <span className="text-muted fw-normal">({parseProgress.currentFileName})</span>
                                    </span>
                                    <span className="small fw-bold text-info">{parseProgress.current} / {parseProgress.total}</span>
                                </div>
                                <div className="progress" style={{ height: '10px' }}>
                                    <div
                                        className="progress-bar progress-bar-striped progress-bar-animated bg-info"
                                        role="progressbar"
                                        style={{ width: `${(parseProgress.current / parseProgress.total) * 100}%` }}
                                    ></div>
                                </div>
                            </div>
                        )}

                        {!parseProgress?.isParsing && uploadProgress.total > 0 && (
                            <div className="upload-progress-bar mb-0 me-4">
                                <div className="d-flex justify-content-between mb-2">
                                    <span className={`small fw-bold text-${uploadProgress.current === uploadProgress.total ? 'success' : 'primary'}`}>
                                        {uploadProgress.current === uploadProgress.total ? 'Carga completada' : 'Subiendo al servidor...'}
                                    </span>
                                    <span className={`small fw-bold text-${uploadProgress.current === uploadProgress.total ? 'success' : 'primary'}`}>
                                        {uploadProgress.current} / {uploadProgress.total}
                                    </span>
                                </div>
                                <div className="progress" style={{ height: '10px' }}>
                                    <div
                                        className={`progress-bar progress-bar-striped ${uploadProgress.current === uploadProgress.total ? 'bg-success' : 'progress-bar-animated bg-primary'}`}
                                        role="progressbar"
                                        style={{ width: `${(uploadProgress.current / uploadProgress.total) * 100}%` }}
                                    ></div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="d-flex align-items-center gap-4">
                        <ButtonPrimary
                            id="carga-masiva-submit"
                            title={isProcessing ? "Procesando..." : `Iniciar Carga de ${pendingCount} Docs`}
                            onClick={uploadAll}
                            disabled={pendingCount === 0 || isProcessing}
                            showLoading={isProcessing}
                        />
                    </div>
                </div>
            </div>
        </ModalBtn>
    );
};

export default CargaMasivaModal;
